import React, { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import ActivitatsIdExercicis from '../../jutge/activitatsId/content/ActivitatsIdExercicis';

export const GameActivityModal: React.FC = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { id_activitat } = useParams();

    useEffect(() => {
        // Solo accesible si está dentro de un iframe (el juego)
        const isInsideIframe = window.self !== window.top;
        if (!isInsideIframe) {
            navigate('/home', { replace: true });
        }
    }, [navigate]);

    return (
        <div style={{
            background: '#fff',
            minHeight: '100vh',
            padding: '24px 28px',
            overflowY: 'auto'
        }}>
            <ActivitatsIdExercicis isGameModal={true} />
        </div>
    );
};

export default GameActivityModal;
